import React, { Fragment } from "react";
import { Row, Col } from "../../../UI/Customstrap/Customstrap";
import { Container } from "../../../UI/Container/Container";
import { Table, Button } from "reactstrap";
import moment from "moment";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";

import style from "./InvestAssetClassTable.scss";

export const InvestAssetClassTable = ({ offers, toggle }) => {
  return (
    <Fragment>
      {offers.map((offer, index) => {
        const available = offer.OfferQuantitytoClient - offer.OfferQuantityTakenByClient;
        return (
          <div className={style.offerCard}>
            <Col xs={12} lg={4} className={style.offerInfo}>
              <span className={`${style.offerField} ${style.name}`}>{offer.AssetName}</span>
              <span className={`${style.offerField} ${style.nominal}`}>
                <span className={style.label}>Rendimiento: </span>
                <FormattedNumber
                  value={offer.NominalRate}
                  minimumFractionDigits={2}
                  maximumFractionDigits={2}
                />
                <span>%</span>
              </span>
              <span className={style.offerField}>
                <span className={style.label}>Cantidad disponible: </span>
                <FormattedNumber
                  value={available}
                  minimumFractionDigits={offer.AssetInformation.CurrencyISO == "USD" ? 2 : 0}
                  maximumFractionDigits={offer.AssetInformation.CurrencyISO == "USD" ? 2 : 0}
                />
              </span>
              <span className={style.offerField}>
                <span className={style.label}>ISIN: </span>
                <span>
                  {offer.AssetInformation.AssetDefaultIdentifierValue
                    ? offer.AssetInformation.AssetDefaultIdentifierValue
                    : "-"}
                </span>
              </span>
            </Col>
            <Col xs={12} lg={5} className={`${style.offerInfo} ${style.secondCol}`}>
              <span className={style.offerField}>
                <span className={style.label}>Calificación de riesgo: </span>
                {offer.AssetInformation.AssetRiskTypeDesc}
              </span>
              <span className={style.offerField}>
                <span className={style.label}>Tipo: </span>
                {offer.AssetInformation.SubAssetClassInfo.SubAssetClassName}
              </span>
              <span className={style.offerField}>
                <span className={style.label}>Vencimiento: </span>
                {offer.AssetInformation.AssetMaturityDate === "0000-00-00"
                  ? "-"
                  : moment(offer.AssetInformation.AssetMaturityDate).format("DD/MM/YYYY")}
              </span>
              <span className={style.offerField}>
                <span className={style.label}>Moneda: </span>
                {offer.AssetInformation.CurrencyISO}
              </span>
            </Col>
            <Col xs={12} lg={3} className={`${style.offerInfo} ${style.thirdCol}`}>
              <div className={style.totalValueWrapper}>
                <span className={style.value}>
                  <FormattedNumber
                    value={(offer.AssetInformation.AssetParValue * offer.OfferPrice) / 100}
                    minimumFractionDigits={offer.AssetInformation.CurrencyISO === "PYG" ? 0 : 2}
                    maximumFractionDigits={offer.AssetInformation.CurrencyISO === "PYG" ? 0 : 2}
                  />
                  <span className={style.currency}> {offer.AssetInformation.CurrencyISO}</span>
                </span>
                <span className={style.label}>Valor por titulo</span>
              </div>
              <Button
                className={style.button}
                onClick={() => {
                  toggle(offer);
                }}
              >
                Pedir cotización
              </Button>
            </Col>
          </div>
        );
      })}
    </Fragment>
  );
};
